<div [class]="containerClass()">
    <form [formGroup]="aiChatPromptForm" (ngSubmit)="executePrompt()">
        <mat-form-field class="input-question ai-chat-prompt-input" id="chat-input">
            <div class="chat-footer-top-action-bar">
                @if (selectedAgents().length > 0 && !isCurrentSessionSubmitting() &&
                !automationStateService.isWaitingForFileUpload()) {
                <div class="agents">
                  @for (agent of selectedAgents(); track agent.id) {
                      <div class="agent chip">
                          <button kendoButton type="button" #tooltip="matTooltip" aria-label="Remove agent"
                              matTooltip="Remove agent" matTooltipPosition="above"
                              (click)="removeAgent(agent)" [svgIcon]="minusOutlineIcon"
                              fillMode="clear"></button>
                           <mat-icon svgIcon="a-circle-icon" class="agent-icon"></mat-icon>
                          <span  #tooltip="matTooltip" [aria-label]="'Agent: ' + agent.name"
                                 [matTooltip]="'Agent: ' + agent.name" matTooltipPosition="above">{{agent.name}}</span>
                      </div>
                  }
                </div>
                }

                @if (chatDocumentService.selectedDocuments().length > 0 && !isCurrentSessionSubmitting() &&
                !automationStateService.isWaitingForFileUpload()) {
                <div class="attachments">
                  @for (attachment of chatDocumentService.selectedDocuments(); track attachment; let idx = $index)
                  {
                      <div class="chip">
                          <button kendoButton type="button" #tooltip="matTooltip" aria-label="Remove attachment"
                              matTooltip="Remove attachment" matTooltipPosition="above"
                              (click)="removeAttachment(idx)" [svgIcon]="minusOutlineIcon"
                              fillMode="clear"></button>
                          <attachment-doc [document]="attachment"></attachment-doc>
                      </div>
                  }

                </div>
                }
            </div>

            <textarea matInput
                      formControlName="content"
                      placeholder="Ask me anything..."
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="3"
                      cdkAutosizeMaxRows="5"
                      (input)="onPromptInput($event); adjustTextareaHeight();"
                      (keydown)="onTextareaKeydown($event)"
                      (keydown.enter)="submitOnEnter($event)"
                      [class.disabled]="isInputDisabled()"
                      [attr.aria-expanded]="!!mentionQuery()"
                      [attr.aria-controls]="mentionQuery() ? 'mention-list-panel' : null"
                      aria-autocomplete="list"
                      role="combobox"
                      #chatInput></textarea>

            <div class="chat-footer-bottom-action-bar">
                <div class="btn-actions-grp">
                    @if (showExportChatButton())
                    {
                        <button type="button" (click)="exportChat()"
                            [disabled]="(chatSessionService.selectedSession()?.messages!.length === 0 || isInputDisabled())"
                                matIconButton #tooltip="matTooltip" matTooltip="Export chat" matTooltipPosition="above"
                            aria-label="Export chat">
                            <mat-icon class="material-symbols-outlined icon-sm btn-file-action"
                                [ngClass]="{'disabled': (chatSessionService.selectedSession()?.messages!.length === 0 || isInputDisabled())}"
                                aria-hidden="true" fontIcon="export_notes" />
                        </button>
                    }
                    <button type="button" (click)="aiChatService.onOpenDocumentManager()" matIconButton #tooltip="matTooltip"
                        matTooltip="Add attachment" matTooltipPosition="above" aria-label="Add attachment"
                        [disabled]="isInputDisabled()">
                        <mat-icon class="material-symbols-outlined icon-sm btn-file-action" aria-hidden="true"
                            [ngClass]="{'disabled': isInputDisabled()}"
                            fontIcon="attach_file" />
                    </button>

                    <!-- AI Model dropdown -->
                    <ai-models
                      [isQuickEdit]="true"
                      [isInputDisabled]="isInputDisabled()"
                      [isStarterConversation]="conversationStarterService.isStartConversation()"
                      (modelSelected)="modelSelected($event)"
                      (temperatureChanged)="updateTemperature($event)"
                      (topPChanged)="updateTopP($event)"
                      (starterConversationModel)="updateStarterConversationModel($event)" />
                </div>

                <div class="btn-actions-grp">
                  <button type="button" matIconButton #tooltip="matTooltip" matTooltip="Clear"
                          matTooltipPosition="above" aria-label="Clear session" (click)="clear()"
                          [disabled]="isInputDisabled() || aiChatPromptForm.get('content')?.value === ''">
                    <mat-icon class="material-symbols-outlined btn-clear"
                              [ngClass]="{'disabled': isInputDisabled()}" fontIcon="close" />
                  </button>

                  <div class="icon-divider"></div>

                    <button type="button" matIconButton (click)="speechInput()"
                        [disabled]="speechActive || isInputDisabled()"
                        #tooltip="matTooltip" aria-label="Use microphone to chat" matTooltip="Use microphone to chat"
                        matTooltipPosition="above">
                        <mat-icon class="material-symbols-outlined btn-mic"
                            [ngClass]="{'disabled': (speechActive || isInputDisabled())}"
                            aria-hidden="true" fontIcon="microphone" />
                    </button>
                    @if (isCurrentSessionSubmitting()) {
                      @if (automationStateService.isWorkflowInProgress()) {
                        <button class="btn-spinner-action" type="button" matIconButton disabled
                                aria-label="Workflow in progress" aria-busy="true">
                          <mat-spinner diameter="24" aria-hidden="true" />
                        </button>
                      } @else {
                        <button class="btn-stop-action" type="button" matIconButton (click)="cancelRequest()"
                                #tooltip="matTooltip" aria-label="Stop generating" matTooltip="Stop generating"
                                matTooltipPosition="above">
                          <mat-icon class="material-symbols-outlined btn-stop" fontIcon="stop_circle" aria-hidden="true" />
                        </button>
                      }
                    } @else {
                      <button type="submit" matIconButton
                          [disabled]="speechActive || isInputDisabled() || conversationStarterService.hasError()"
                          #tooltip="matTooltip" aria-label="Submit question" matTooltip="Submit question"
                          matTooltipPosition="above">
                          <mat-icon class="material-symbols-outlined btn-send"
                                    [class.disabled]="{'disabled': (speechActive || isInputDisabled() || conversationStarterService.hasError())}"
                              fontIcon="send" aria-hidden="true" />
                      </button>
                    }
                </div>
            </div>
        </mat-form-field>
    </form>
</div>

<ng-template #mentionList>
  <div class="mention-list-panel obsidian-theme"
       id="mention-list-panel"
       role="listbox"
       aria-label="Available agents">
    <div class="mention-list-header">
      <mat-icon svgIcon="a-circle-icon" class="header-icon" aria-hidden="true"></mat-icon>
      <span>Agents</span>
    </div>
    @if (agentsLoading()) {
      <div class="loading-state" role="status" aria-live="polite">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="sr-only">Loading agents...</span>
      </div>
    } @else {
      @for (agent of filteredAgents(); track agent.id; let idx = $index) {
        <button (click)="selectMention(agent.name)"
                class="mention-item"
                [class.focused]="idx === focusedMentionIndex()"
                role="option"
                [attr.aria-selected]="idx === focusedMentionIndex()"
                [attr.id]="'mention-item-' + idx">
          {{ agent.name }}
        </button>
      } @empty {
        <div class="no-results" role="status">No agents found.</div>
      }
    }
  </div>
</ng-template>
